/**
 * Cleo ERP SaaS — Routing principal
 */
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';

import PublicLayout from './components/layout/PublicLayout';
import ClientLayout from './components/layout/ClientLayout';
import AdminLayout from './components/layout/AdminLayout';
import ProtectedRoute from './components/common/ProtectedRoute';

import RegisterPage from './pages/public/RegisterPage';
import VerifyEmailPage from './pages/public/VerifyEmailPage';
import LoginPage from './pages/public/LoginPage';
import DashboardPage from './pages/client/DashboardPage';

import TenantListPage from './pages/admin/TenantListPage';
import TenantDetailPage from './pages/admin/TenantDetailPage';
import ConfigPage from './pages/admin/ConfigPage';

import BillingSubscriptionListPage from './pages/admin/billing/BillingSubscriptionListPage';
import BillingSubscriptionDetailPage from './pages/admin/billing/BillingSubscriptionDetailPage';
import BillingInvoiceListPage from './pages/admin/billing/BillingInvoiceListPage';
import BillingEventListPage from './pages/admin/billing/BillingEventListPage';
import BillingConfigPage from './pages/admin/billing/BillingConfigPage';

function App() {
  const { isAuthenticated, isAdmin } = useAuth();

  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/verify-email/:token" element={<VerifyEmailPage />} />
        <Route path="/login" element={<LoginPage />} />
      </Route>

      <Route element={
        <ProtectedRoute requiredType="CLIENT">
          <ClientLayout />
        </ProtectedRoute>
      }>
        <Route path="/dashboard" element={<DashboardPage />} />
      </Route>

      <Route element={
        <ProtectedRoute requiredType="ADMIN">
          <AdminLayout />
        </ProtectedRoute>
      }>
        <Route path="/admin/tenants" element={<TenantListPage />} />
        <Route path="/admin/tenants/:id" element={<TenantDetailPage />} />
        <Route path="/admin/config" element={<ConfigPage />} />
        <Route path="/admin/billing/subscriptions" element={<BillingSubscriptionListPage />} />
        <Route path="/admin/billing/subscriptions/:id" element={<BillingSubscriptionDetailPage />} />
        <Route path="/admin/billing/invoices" element={<BillingInvoiceListPage />} />
        <Route path="/admin/billing/events" element={<BillingEventListPage />} />
        <Route path="/admin/billing/config" element={<BillingConfigPage />} />
      </Route>

      <Route path="/" element={
        isAuthenticated
          ? isAdmin
            ? <Navigate to="/admin/tenants" replace />
            : <Navigate to="/dashboard" replace />
          : <Navigate to="/register" replace />
      } />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
